<!-- FÓKUSZ téma: sötét sáv a modul ikonjával, fülek, cég + év, profil (a NAPLO/BÉR fejlécének párja). -->
<ion-header class="s-fej" *ngIf="fokusz; else klasszikusFej">
  <div class="s-sav">
    <ion-menu-button class="s-hamb csak-mobil" title="Profil, intézmény- és modulváltás"></ion-menu-button>
    <button class="s-marka" type="button" (click)="open('/inventario/kezdolap')" [title]="alrendszerNev">
      <img class="s-logo" [src]="modIkon" alt="">
      <span class="s-marka-szoveg">{{ alrendszerNev }}</span>
    </button>
    <nav class="s-fulek">
      <button *ngFor="let f of fulek" type="button" [class.aktiv]="aktivUt === f.ut || !!f.tobb?.includes(aktivUt)" (click)="open(f.ut)" [title]="f.cim">
        <ion-icon [name]="f.ikon"></ion-icon><span>{{ f.cim }}</span>
      </button>
    </nav>
    <div class="s-ter"></div>
    <button class="s-ugyfel" type="button" (click)="valasztoNyit()" title="Cég választása">
      <span class="s-szerep" *ngIf="aktiv.szerep" [attr.data-sz]="aktiv.szerep">{{ aktiv.szerep === 'ugyfel' ? 'SAJÁT CÉG' : 'KÖNYVELŐ' }}</span>
      <span class="s-ugyfel-nev">{{ aktiv.ugyfelNev || 'Válassz céget' }}</span>
      <ion-icon name="swap-horizontal-outline"></ion-icon>
    </button>
    <select class="s-ev" [ngModel]="aktiv.ev" (ngModelChange)="evValt($event)" title="Év">
      <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
    </select>
    <app-profil-menu class="csak-asztal"></app-profil-menu>
  </div>
</ion-header>

<!-- KLASSZIKUS téma: eszköztár (a menüt a bal sáv adja). -->
<ng-template #klasszikusFej>
  <ion-header [translucent]="true">
    <ion-toolbar class="inventario-toolbar">
      <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
      <ion-title>
        <span class="s-cim"><img class="s-ikon" [src]="modIkon" alt=""> {{ alrendszerNev }}</span>
      </ion-title>
      <ion-buttons slot="end">
        <ion-chip class="s-chip" outline (click)="valasztoNyit()">
          <ion-icon name="business"></ion-icon>
          <ion-label>{{ aktiv.ugyfelNev || 'Nincs kiválasztott cég' }}</ion-label>
        </ion-chip>
        <select class="s-ev klasszikus" [ngModel]="aktiv.ev" (ngModelChange)="evValt($event)">
          <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
        </select>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
</ng-template>

<ion-content class="s-tartalom">
  <div class="s-olvaso" *ngIf="aktiv.ugyfelId && aktiv.szerep === 'konyvelo'">
    <ion-icon name="eye-outline"></ion-icon>
    <span><b>Könyvelői nézet – csak olvasás.</b> A készletet a cég kezeli a saját belépésével; innen megnézheted és ellenőrizheted.</span>
  </div>
  <router-outlet></router-outlet>
</ion-content>

<!-- Cégválasztó: a látható cégek szereppel -->
<ion-modal [isOpen]="valasztoNyitva" (didDismiss)="valasztoNyitva = false" cssClass="bevsor-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Cég választása</ion-title></ion-toolbar></ion-header>
    <div class="bv-torzs s-valaszto">
      <div class="n-szuro-sor">
        <input type="search" [(ngModel)]="kereso" placeholder="Keresés névre, adószámra…" autofocus
               (keydown.enter)="lathatoUgyfelek.length && ugyfelValaszt(lathatoUgyfelek[0])">
        <span class="spacer"></span><span class="halvany">{{ lathatoUgyfelek.length }} cég</span>
      </div>
      <div class="tabla-wrap">
        <table class="n-racs">
          <thead><tr><th>Cég</th><th>Adószám</th><th>Szerep</th></tr></thead>
          <tbody>
            <tr *ngFor="let u of lathatoUgyfelek" class="kattinthato" [class.aktiv]="u.id === aktiv.ugyfelId" [class.inaktiv]="u.inaktiv" (click)="ugyfelValaszt(u)">
              <td><b>{{ u.nev }}</b></td><td>{{ u.adoszam }}</td>
              <td><span class="s-szerep" [attr.data-sz]="u.szerep">{{ u.szerep === 'ugyfel' ? 'saját cég – számlázás' : 'könyvelő – olvasás' }}</span></td>
            </tr>
          </tbody>
        </table>
        <div class="ures" *ngIf="!lathatoUgyfelek.length">Nincs elérhető cég. Ügyfélként a könyvelőiroda adhat hozzáférést (Készletkezelés → Beállítások → Ügyfél-hozzáférés).</div>
      </div>
      <div class="sa-lab" style="padding:10px 14px"><span class="spacer"></span>
        <button type="button" class="ov-gomb" (click)="valasztoNyitva = false">Bezár</button></div>
    </div>
  </ng-template>
</ion-modal>
